// Apply styles to Shopify policy pages that are not directly accessible for styling
document.addEventListener('DOMContentLoaded', function() {
  const policyContainer = document.querySelector('.shopify-policy__container');
  const main = document.querySelector('main');
  
  if (policyContainer && main) {
    // Apply gradient repeating image background to main
    main.style.backgroundImage = 'linear-gradient(180deg, #0000009e 20%, #ffffff1a), url(https://cdn.shopify.com/s/files/1/0699/3149/9683/files/IMG_0160.png?v=1755773575)';
    main.style.backgroundColor = '#000';
    main.style.backgroundPosition = '0 0, 0 0';
    main.style.backgroundSize = 'auto, 40px';
    main.style.backgroundAttachment = 'scroll, fixed';
    main.style.backgroundRepeat = 'repeat';
    
    // Apply top padding like press section
    main.style.setProperty('padding-top', 'calc(var(--header-height, 80px) + 20px)', 'important');
    main.style.setProperty('padding-bottom', '32px', 'important');
    
    // Apply grid styles from collection list page to make main take up full vh
    document.body.style.setProperty('display', 'grid', 'important');
    document.body.style.setProperty('grid-template-rows', 'auto 1fr auto', 'important');
    main.style.setProperty('display', 'grid', 'important');
    main.style.setProperty('grid-template-rows', '1fr', 'important');
    
    // Apply MEKINSA font to policy title
    const policyTitle = policyContainer.querySelector('.shopify-policy__title');
    if (policyTitle) {
      policyTitle.style.setProperty('font-family', "'MEKINSA', sans-serif", 'important');
      policyTitle.style.setProperty('font-size', '50px', 'important');
      policyTitle.style.setProperty('line-height', '60px', 'important');
      policyTitle.style.setProperty('margin-top', '0', 'important');
      policyTitle.style.setProperty('margin-bottom', '3rem', 'important');
      policyTitle.style.setProperty('text-align', 'center', 'important');
    }
    
    // Override universal * selector for all elements within policy container
    const allPolicyElements = policyContainer.querySelectorAll('*');
    allPolicyElements.forEach(function(element) {
      if (element.classList.contains('shopify-policy__title') || element.closest('.shopify-policy__title')) {
        element.style.setProperty('font-family', "'MEKINSA', sans-serif", 'important');
      }
    });
    
    // Apply Courier Prime font to policy body
    const policyBody = policyContainer.querySelector('.shopify-policy__body');
    if (policyBody) {
      policyBody.style.fontFamily = "'Courier Prime', sans-serif";
    }
  }
});